/**
 * Analytics identifiers for WOODWORKING FURNITURE PLANS™.
 *
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '1998322494134236'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
